/**
 * Created by Owlz on 24/10/2017.
 */
"use strict";

import Sprite3D from "./Sprite3D";
import Shake    from "./Shake";

/**
 * @class
 */
export default class PeekingBetty extends Sprite3D {
    /**
     * @param texName {String} - texture name
     * @param holder {*|PIXI.projection.Container2d} - optional holder to add to
     * @param scoreManager {ScoreManager}
     */
    constructor(texName, holder, scoreManager) {
        super(texName, null);

        /**
         * @type {*|PIXI.projection.Container2d}
         * @private
         */
        this._container3D = holder;

        /**
         * @type {number}
         * @private
         */
        this._moveSpeed = Common.config.peek_speed;

        /**
         * @type {boolean}
         * @private
         */
        this._sleep = true;

        /**
         * @type {string}
         * @private
         */
        this._currentState = "";

        /**
         * @type {{left: function, right: function, up: function}}
         * @private
         */
        this._peekStates = {
            "left": (f) => this._peekTween(-1, f),
            "right": (f) => this._peekTween(1, f),
            "up": (f) => this._peekTween(0, f)//use zero for peeking upwards (not sure this will even be used)
        };

        /**
         * @type {number}
         * @private
         */
        this._peekDistance = 250;

        /**
         * @type {number}
         * @private
         */
        this._tweenTime = this._peekDistance / this._moveSpeed;

        /**
         * @type {boolean}
         * @private
         */
        this._sleep = true;

        /**
         * @type {ScoreManager}
         * @private
         */
        this._scoreManager = scoreManager;

        /**
         * @type {boolean}
         * @private
         */
        this._isReal = false;

        /**
         * @type {Array}
         * @private
         */
        this._explodingPieces = [];

        /**
         * @type {null|PIXI.Container}
         * @private
         */
        this._particleHolder = new PIXI.Container();

        /**
         * @type {null}
         * @private
         */
        this._emitter = null;

        /**
         * @type {null}
         * @private
         */
        this._emitter2 = null;

        /**
         * @type {Array}
         * @private
         */
        this._projectiles = [];

        /**
         * @type {number}
         * @private
         */
        this._projectileSpeed = Common.config.projectile_speed;

        this._myShake = new Shake();

        this.init();
    }

    init() {

        this._initParticles();

        let hitArea = P3.createSprite(PIXI.Texture.EMPTY, this.view);
        hitArea.width = this.view.width * 0.5;
        hitArea.height = this.view.height * 0.5;
        hitArea.anchor.set(0.5);
        hitArea.y = -this.view.height * 0.5;

        hitArea.interactive = true;
        hitArea.pointerdown = hitArea.touchstart = this._inputdown.bind(this);


        this._myShake.setTarget(this.view);
        this._myShake.maxOffsetX = 175;//big ol shake
        this._myShake.maxOffsetY = 125;//less y shake otherwise they might shake out from underneath wall tile

        this.goToSleep();

    }

    update() {

        this._myShake.update(deltaTime);

        for (let i = 0; i < this._explodingPieces.length; i++) {
            this._explodingPieces[i].x += this._explodingPieces[i].dx * P3.deltaTime;
            this._explodingPieces[i].y += this._explodingPieces[i].dy * P3.deltaTime;
        }

        //--update projectile spine animation--//
        const len = this._projectiles.length;
        for (let i = 0; i < len; i++) {
            this._projectiles[i].view.update(P3.deltaTime)
        }

        this._emitter.update(P3.deltaTime * 0.5);
        this._emitter2.update(P3.deltaTime * 0.5);
        this._particleHolder.x = this._view.x;
        this._particleHolder.y = this._view.y - this._view.height * 0.5;

    }

    wakeUp(fire) {

        this.dieing = false;

        this.view.visible = true;
        this._sleep = false;
        if (!this._isReal) {
            this._emitter.emit = true;
            this._emitter2.emit = true;
        }

        this.setTint();
    }

    goToSleep() {

        TweenMax.killTweensOf(this._view);
        this._view.x = 0;
        this._view.y = 65;
        this.view.visible = false;
        this._sleep = true;

        this._emitter.emit = false;
        this._emitter2.emit = false;

        this.setTint();
    }

    /**
     * @deprecated
     */
    setTint() {
        //   if (this._isReal) {
        ///      this._tint = 0x37FDFC;
        //  } else {
        ///      this._tint = 0xDD0048;
        ///   }
        //   this._glowFilter = new PIXI.filters.GlowFilter(25, 0, 0, this._tint, 0.2);
    }

    _inputdown(event) {

        if (this._sleep || !this._scoreManager.gotBullets() || this.dieing || Common.paused) return;

        this.dieing = true;

        if (this._isReal) {
            this._scoreManager.resetMultiplier();
            this._scoreManager.hitPlayer();
        } else {
            this._scoreManager.addMultiplier();
            this._scoreManager.addScore();
        }

        this.view.tint = this._tint;

        this._scoreManager.useBullet();

        this._playLaserSound();
        this._playHitSound();

        this._shake(this, ()=> {
            if (!this._isReal) this._createAnimatedScore();
            this._explode();
            this.goToSleep();
        });

        //--create particle effect--//
        const assets = Common.assets;
        const textures = assets.texture("part_hit_shot_1");
        const config = assets.json("part_hit_shot");
        const emitter = new PIXI.particles.Emitter(this, textures, config);

        const local = event.data.getLocalPosition(this);
        emitter.updateOwnerPos(local.x, local.y);

        emitter.playOnce(()=> {
            this.removeChild(emitter);
            emitter.destroy();
        });
    }

    /**
     * @returns {Tween}
     */
    peek(fire) {

        //--small chance to be a good betty--//
        if (Math.random() < 0.2 && !fire) {
            this.view.texture = Common.assets.texture("betty_good");
            this._isReal = true;
        } else {
            this.view.texture = Common.assets.texture("betty_bad");
            this._isReal = false;
        }

        this.wakeUp();

        return this._peekStates[this._currentState](fire);
    }

    /**
     * @param dir
     * @returns {Tween}
     * @private
     */
    _peekTween(dir, fire) {
        if (TweenMax.isTweening(this._view)) return;

        let target, tween;
        if (dir !== 0) {
            target = this._view.x + this._peekDistance * dir;
            tween = TweenMax.to(this._view, this._tweenTime, {
                x: target,
                yoyo: true,
                repeat: 1,
                repeatDelay: 1,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    this.goToSleep();
                }
            })
        } else {
            target = this._view.y - this._peekDistance;
            tween = TweenMax.to(this._view, this._tweenTime, {
                y: target,
                yoyo: true,
                repeat: 1,
                repeatDelay: 1,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    this.goToSleep();
                }
            })
        }

        if (!this._isReal && Math.random() < 0.25 || fire) {
            delay(()=> {
                this._fireProjectile();
            }, this._tweenTime, this);
        }

        return tween;
    }

    /**
     * @private
     */
    _initParticles() {

        // this._particleHolder
        // console.log("peeking init particles");
        this._particleHolder.scale.set(0.4);
        this._particleHolder.y -= this.view.height * 0.5;
        this.addChild(this._particleHolder, this._view);

        this._emitter = P3.createParticles(this._particleHolder, "part_virus_1", {
            name: "part_virus_2_",
            count: 1
        }, null, true);
        this._emitter.emit = true;

        this._emitter2 = P3.createParticles(this._particleHolder, "part_virus_2", {
            name: "part_virus_",
            count: 3
        }, null, true);
        this._emitter2.emit = true;

    }

    /**
     * @deprecated
     * @public
     */
    testPeek() {
        // this._peek();
        delay(() => {
            this.testPeek();
        }, P3.math.randomInt(8, 12), this);
    }

    /**
     * @private
     */
    _playLaserSound() {
        Common.audio.playSound([
            "sfx_firelaser1",
            "sfx_firelaser2",
            "sfx_firelaser3"
        ]);
    }

    /**
     * @private
     */
    _playHitSound() {
        if (!this._isReal) {
            Common.audio.playSound("sfx_enemyhit");
        } else {
            Common.audio.playSound("sfx_realwendyhit");
        }
    }

    /**
     * @param element
     * @param cb
     * @private
     */
    _shake(element, cb) {
        //changed to use my new shake class
        this._myShake.onShakeEnd = cb;
        this._myShake.trauma = 0.25;
        /*
         const t = 0.05;
         const startX = this.x;
         TweenMax.to(element, t, {
         x: this.x - 15,
         ease: Quad.easeInOut
         });
         TweenMax.to(element, t, {
         repeat: 4,
         x: this.x + 15,
         yoyo: true,
         delay: 0.1,
         ease: Quad.easeInOut
         });
         TweenMax.to(element, t, {
         x: startX,
         delay: t * 4,
         onComplete: cb.bind(this)
         });
         */
    }

    /**
     * @private
     */
    _explode() {
        let texName = "betty_bad_part_";
        if (this._isReal) {
            texName = "betty_good_part_";
        }

        const pieces = [];
        for (let i = 1; i <= 9; i++) {
            const piece = P3.createSprite(texName + i, this);
            piece.scale.set(0.65);
            piece.position.set(this.view.x, this.view.y - this.view.height * 0.5);
            piece.dx = P3.randomInt(-400, 400);
            piece.dy = P3.randomInt(-150, 0);
            piece.anchor.set(0.5);
            pieces.push(piece);
        }
        this._explodingPieces = pieces;

        delay(this._cleanupPieces.bind(this), 0.15, this);
    }

    _cleanupPieces() {
        const len = this._explodingPieces.length;
        const t = 0.5;
        for (let i = 0; i < len; i++) {
            TweenMax.to(this._explodingPieces[i], t, {
                alpha: 0,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    this.removeChild(this._explodingPieces[i]);
                }
                , delay: 0.3
            });
        }
        delay(()=> {
            for (let i = 0; i < len; i++) {
                this._explodingPieces[i].destroy();
            }
            this._explodingPieces.length = 0;
        }, t + 0.4, this);
    }

    _createAnimatedScore() {
        const view = createText("" + this._scoreManager.getHitValue(), {
            size: 95,
            fill: 0xffffff,
            stroke: "black",
            strokeWidth: 5
        });
        view.x = this.view.x;
        view.y = this.view.y - 175;
        this.addChild(view);
        TweenMax.to(view, 0.25, {
            y: view.y - 200,
            ease: Power2.easeOut,
            onComplete: ()=> {
                TweenMax.to(view, 0.15, {
                    alpha: 0,
                    y: -P3.View.height,
                    ease: Power2.easeIn,
                    delay: 0.2,
                    onComplete: ()=> {
                        this.removeChild(view);
                        view.destroy();
                    }
                });
            }
        });
    }

    /**
     * @private
     */
    _fireProjectile() {

        //   if (this.y > -P3.View.height || this.x < 0 || this.x > P3.View.width || this._sleep) return;//don't fire if betty is close to screen or edges

        const projectile = new Sprite3D();
        projectile.position.set(this.x + this.view.x, this.y);
        projectile.view = P3.createSpine("projectile_1", "animation");
        projectile.view.autoUpdate = false;
        projectile.addChild(projectile.view);

        projectile.view.y = this._view.y - 75;

        const dist = Common.distance(projectile.x, projectile.y, 0, 0);//distance to zero is just as good really
        const vel = this._projectileSpeed;
        const t = dist / vel;

        const tw1 = TweenMax.to(projectile, t, {
            x: P3.View.width * 0.5 + P3.math.randomInt(-250, 250),
            y: 0,
            ease: Power0.easeNone,
            onComplete: ()=> {

                //--add a decal in this position--//
                let decal = P3.createSprite("hit_decal", Common.world);
                decal.anchor.set(0.5);

                let global = projectile.view.toGlobal(Common.world);
                decal.x = /*(Common.STAGE_WIDTH - P3.View.width) * 0.5 + */ global.x - P3.View.width * 0.5;
                decal.y = global.y - P3.View.height * 0.5;
                decal.alpha = 0.75;

                // TweenMax.to(decal.scale, 1, {x: 2, y: 2, ease: Power0.easeNone});

                TweenMax.to(decal, 0.5, {
                    alpha: 0,
                    delay: 0.5,
                    onComplete: ()=> {
                        decal.destroy();
                    }
                });

                TweenMax.killTweensOf(projectile.view);
                TweenMax.killTweensOf(projectile);
                this._container3D.removeChild(projectile);
                projectile.destroy();
                const index = this._projectiles.indexOf(projectile);
                this._projectiles.splice(index, 1);
                this._scoreManager.hitPlayer();
            }
        });
        let targ = P3.math.randomInt(-350, -450);

        const tw2 = TweenMax.to(projectile.view, t * 0.5, {
            y: projectile.view.y - 550,
            ease: Power1.easeOut
        });

        const tw3 = TweenMax.to(projectile.view, t * 0.5, {
            y: targ,
            ease: Power1.easeIn,
            delay: t * 0.5
        });

        projectile.tweens = [tw1, tw2, tw3];

        this._container3D.addChild(projectile);
        this._projectiles.push(projectile);

        projectile.interactive = true;
        projectile.mousedown = projectile.touchstart = this._projectileDown.bind(this);

        Common.audio.playSound("sfx_enemyfire");

        this.lastFired = projectile;
    }

    /**
     * @param event
     * @private
     */
    _projectileDown(event) {

        if (!this._scoreManager.gotBullets()) {
            return;
        } else {
            this._scoreManager.useBullet();
        }

        this._playLaserSound();

        const projectile = event.target;
        if (projectile.deflected) return;

        TweenMax.killTweensOf(projectile);
        projectile.deflected = true;

        TweenMax.to(projectile, 0.25, {
            x: P3.View.width * 0.5 + P3.math.randomInt(-P3.View.width, P3.View.width),
            y: -P3.View.height * 8,//double full depth
            ease: Power0.easeNone,
            onComplete: ()=> {
                TweenMax.killTweensOf(projectile.view);
                TweenMax.killTweensOf(projectile);
                this._container3D.removeChild(projectile);
                projectile.destroy();
                const index = this._projectiles.indexOf(projectile);
                this._projectiles.splice(index, 1);
            }
        });
        TweenMax.to(projectile.view, 0.25, {
            y: P3.math.randomInt(-500, -800),
            ease: Power0.easeNone
        });

        this._playLaserSound();

        Common.audio.playSound("sfx_deflectshot");

        if (this._onTutProjectileDown) {
            this._onTutProjectileDown();
            this._onTutProjectileDown = null;//cb and remove
        }
    }

    get sleep() {
        return this._sleep;
    }

    set sleep(value) {
        this._sleep = value;
    }

    set currentState(value) {
        this._currentState = value;
    }

    set isReal(value) {
        this._isReal = value;
    }

    set onTutProjectileDown(value) {
        this._onTutProjectileDown = value;
    }
}